module.exports = __webpack_public_path__ + "img/just-eat-logo.6eb14b9c.png";